import { render, staticRenderFns } from "./newTemplete.vue?vue&type=template&id=3f6ab9e1&scoped=true&"
import script from "./newTemplete.vue?vue&type=script&lang=js&"
export * from "./newTemplete.vue?vue&type=script&lang=js&"
import style0 from "./newTemplete.vue?vue&type=style&index=0&id=3f6ab9e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ab9e1",
  null
  
)

export default component.exports